export const GlobalSpinner = () => (
  <div className="grid min-h-screen place-items-center bg-app">
    <div className="size-8 animate-spin rounded-full border-2 border-border-strong border-t-brand-primary" />
  </div>
)
